module.exports = __webpack_public_path__ + "img/light.4742ef01.png";